import styled from 'styled-components';

import { useEditSavedRowDesignContext } from 'modules/templateEditor/context/EditSavedRowDesignContext';
import { WarningFill } from 'ui/icons';
import { caption } from 'ui/theme';
import { Tooltip } from 'ui/tooltip';

import { useEditableFieldsContext } from '../../context/EditableFieldsContext';
import { displayContent } from '../content';
import { getRelativeTimeInfo } from '../utils';

const LastSaved = styled.div`
  ${caption};
  align-items: flex-end;
  color: ${({ theme }) => theme.colors.textColors.textSecondary};
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-right: ${({ theme }) => theme.spacing.utils.pxToRem(2)};
  row-gap: ${({ theme }) => theme.spacing.utils.pxToRem(4)};
`;

const Message = styled.div<{ isDirty?: boolean }>`
  align-items: center;
  column-gap: ${({ theme }) => theme.spacing.utils.pxToRem(4)};
  display: flex;
  justify-content: flex-end;
  ${({ isDirty }) => isDirty && `font-weight: 600;`}
`;

export const LastSavedIndicator = () => {
  const { liveTemplate, isDirty } = useEditableFieldsContext();
  const { savedRow, isEditingSavedRowDesign, hasUnsavedSavedRowDesignChanges } =
    useEditSavedRowDesignContext();

  const templateUpdatedTime = liveTemplate.updatedAt || liveTemplate.createdAt;
  const savedRowUpdatedTime = savedRow?.updatedAt || savedRow?.createdAt;

  // NOTE: relTime is displayed in the UI, so do not define the locale (the locale of the browser will be used)
  const relTime = getRelativeTimeInfo(savedRowUpdatedTime || templateUpdatedTime);
  const hasUnsavedChanges = isEditingSavedRowDesign ? hasUnsavedSavedRowDesignChanges : isDirty;

  return (
    <LastSaved data-test="last-saved-indicator">
      {hasUnsavedChanges && (
        <Message isDirty={hasUnsavedChanges}>
          <WarningFill isColorInherited />
          <span>{displayContent.labelUnsavedChanges}</span>
        </Message>
      )}
      <Message>
        <span>{displayContent.labelLastSaved}</span>
        <Tooltip isUnderlined tooltipContent={relTime.tooltip}>
          {relTime.label}
        </Tooltip>
      </Message>
    </LastSaved>
  );
};

export default LastSavedIndicator;
